import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import NewsFeed from "./components/NewsFeed";
import CategoryDigest from "./components/CategoryDigest";
import Debate from "./components/Debate";
import AboutFaq from "./components/AboutFaq";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  useEffect(() => {
    document.title = "吃瓜最新 · 今日新瓜热榜 | 当天热点一手速递";
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <HotBoard />
        <NewsFeed />
        <CategoryDigest />
        <Debate />
        <AboutFaq />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}